import React from "react";
import { Dumbbell } from "lucide-react";

// CommunityPump brand mark
export function Logo({ size = 36, className = "" }) {
  return (
    <div className={`rounded-lg bg-[#FF6B6B] flex items-center justify-center ${className}`} style={{ width: size, height: size }}>
      <Dumbbell style={{ width: size * 0.56, height: size * 0.56 }} className="text-[#121212]" strokeWidth={2.6} />
    </div>
  );
}

export function Wordmark({ className = "" }) {
  return (
    <span className={`font-display font-black tracking-tight text-white ${className}`}>
      COMMUNITY<span className="text-[#FF6B6B]">PUMP</span>
    </span>
  );
}
